// Presentation helpers for general notes (C10): human dates, steady avatar
// colours and initials. Shared by the client panel and Henry's admin panel.

const TIME = new Intl.DateTimeFormat('en-AU', { hour: 'numeric', minute: '2-digit', hour12: true });
const DAY = new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });

function startOfDay(ms: number): number {
  const d = new Date(ms);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/** "Today, 9:05 am", "Yesterday, 4:15 pm", else "Tue 4 Nov, 10:42 am".
 *  Never relative ("3h ago"): notes are a record, not a chat. */
export function formatNoteTime(ms: number, now: number = Date.now()): string {
  const time = TIME.format(ms).replace(/\s+/g, ' ').toLowerCase();
  const days = Math.round((startOfDay(now) - startOfDay(ms)) / 86_400_000);
  if (days === 0) return `Today, ${time}`;
  if (days === 1) return `Yesterday, ${time}`;
  // en-AU gives "Tue, 4 Nov"; the mock-up reads "Tue 4 Nov".
  return `${DAY.format(ms).replace(',', '')}, ${time}`;
}

// Teal first, then the scratchpad's muted family, so avatars never compete
// with the teal used for actions.
const TONES = ['bg-accent', 'bg-scratch-structure', 'bg-scratch-idea', 'bg-scratch-line', 'bg-gold-deep'];

/** The same name always gets the same colour, on every device. */
export function avatarTone(name: string): string {
  const key = name.trim().toLowerCase();
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return TONES[hash % TONES.length];
}

export function initialOf(name: string): string {
  return (name.trim()[0] ?? '?').toUpperCase();
}

export function sameName(a: string, b: string): boolean {
  const norm = (s: string) => s.trim().replace(/\s+/g, ' ').toLowerCase();
  return norm(a) !== '' && norm(a) === norm(b);
}
